(function(){
  var key = 'cloque_favorites';
  function read(){ try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch(e){ return []; } }
  function write(items){ try { localStorage.setItem(key, JSON.stringify(items)); } catch(e){} }
  function sync(btn, items){
    var handle = btn.getAttribute('data-wishlist-product');
    var active = items.indexOf(handle) !== -1;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', (active ? 'Remove from favorites' : 'Add to favorites'));
    var label = btn.querySelector('span');
    if(label && btn.classList.contains('cd-pdp-wishlist-button')){
      label.textContent = active ? 'Saved to favorites' : 'Save to favorites';
    }
  }
  function init(){
    var items = read();
    document.querySelectorAll('[data-wishlist-product]').forEach(function(btn){
      sync(btn, items);
      btn.addEventListener('click', function(evt){
        evt.preventDefault(); evt.stopPropagation();
        items = read();
        var handle = btn.getAttribute('data-wishlist-product');
        var idx = items.indexOf(handle);
        if(idx === -1){ items.push(handle); } else { items.splice(idx, 1); }
        write(items); sync(btn, items);
      });
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

(function(){
  function initInstagramShare(){
    document.querySelectorAll('.cd-instagram-share').forEach(function(btn){
      if(btn.dataset.cdBound === 'true') return;
      btn.dataset.cdBound = 'true';
      btn.addEventListener('click', function(evt){
        evt.preventDefault();
        var url = btn.getAttribute('data-share-url') || window.location.href;
        var label = btn.querySelector('.cd-instagram-share__label');
        function done(){
          if(label){
            var old = label.textContent;
            label.textContent = 'Link copied';
            setTimeout(function(){ label.textContent = old; }, 2200);
          }
        }
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var temp = document.createElement('input');
          temp.value = url; document.body.appendChild(temp); temp.select();
          try { document.execCommand('copy'); } catch(e) {}
          document.body.removeChild(temp); done();
        }
      });
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initInstagramShare); } else { initInstagramShare(); }
  document.addEventListener('shopify:section:load', initInstagramShare);
})();

(function(){
  function initInstagramShare(){
    document.querySelectorAll('.cd-instagram-share').forEach(function(btn){
      if(btn.dataset.cdBound === 'true') return;
      btn.dataset.cdBound = 'true';
      btn.addEventListener('click', function(evt){
        evt.preventDefault();
        var url = btn.getAttribute('data-share-url') || window.location.href;
        var label = btn.querySelector('.cd-instagram-share__label');
        function done(){
          if(label){
            var old = label.textContent;
            label.textContent = 'Link copied';
            setTimeout(function(){ label.textContent = old; }, 2200);
          }
        }
        if(navigator.share){
          navigator.share({title: document.title, text: 'Cloque & Dagger', url: url}).then(done).catch(function(){});
          return;
        }
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var temp = document.createElement('input');
          temp.value = url; document.body.appendChild(temp); temp.select();
          try { document.execCommand('copy'); } catch(e) {}
          document.body.removeChild(temp); done();
        }
      });
    });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initInstagramShare); } else { initInstagramShare(); }
  document.addEventListener('shopify:section:load', initInstagramShare);
})();
